import { useState } from '@wordpress/element';
import { CloseButtonSVG } from "../icon";
import { closeBanner } from "../helper/axios";

const EventBanner = ({ bannerData }) => {
    const [close, setClose] = useState(false);
    if (!bannerData) return null;

    const today = new Date();
    const expired = new Date(bannerData?.expired);

    if (!(today <= expired) || close) return null;

    return (
        <div className="jkit-discount-banner">
            <a href={bannerData?.url + '&utm_medium=dashboard-discount-banner'} target="_blank" rel="noreferrer" >
                <img src={bannerData?.banner} alt="event-banner" />
            </a>
            <button onClick={() => closeBanner(setClose)} type="button" className="jkit-close-banner"><CloseButtonSVG /></button>
        </div>
    );
};

export default EventBanner;
